var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container", attrs: { loading: _vm.loading } },
    [
      _c(
        "div",
        { staticClass: "fixedButton" },
        [
          _c(
            "vxe-button",
            { staticClass: "examineButton", on: { click: _vm.ReturnFun } },
            [_vm._v("返回")]
          ),
          _c(
            "vxe-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "examineButton",
              attrs: { status: "success" },
              on: {
                click: function ($event) {
                  return _vm.submint(0)
                },
              },
            },
            [_vm._v("保存")]
          ),
          _c(
            "vxe-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "examineButton",
              attrs: { status: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submint(1)
                },
              },
            },
            [_vm._v("保存并发布")]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "CertificateReleaseApplicationBox scrollBars ActivityPlanReviewExamine",
          style: "height:" + (_vm.$store.state.app.height - 70) + "px;",
        },
        [
          _c("BasicInformation", {
            ref: "BasicInformation",
            attrs: { activity: _vm.activity, "class-type": _vm.classType },
            on: {
              "update:activity": function ($event) {
                _vm.activity = $event
              },
              "update:classType": function ($event) {
                _vm.classType = $event
              },
              "update:class-type": function ($event) {
                _vm.classType = $event
              },
            },
          }),
          _c("reimburseInformation", {
            attrs: { activity: _vm.activity },
            on: {
              "update:activity": function ($event) {
                _vm.activity = $event
              },
            },
          }),
          _c("dealerList", {
            ref: "dealerListDom",
            attrs: { "model-table": _vm.modelTable, "act-plan": _vm.activity },
            on: {
              "update:modelTable": function ($event) {
                _vm.modelTable = $event
              },
              "update:model-table": function ($event) {
                _vm.modelTable = $event
              },
              "update:actPlan": function ($event) {
                _vm.activity = $event
              },
              "update:act-plan": function ($event) {
                _vm.activity = $event
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }